import React from "react";
import SectionTitle from "../components/SectionTitle";
import Banner from "./components/Banner";
import Positions from "./components/Positions";
import { positions } from "./data/positions";
import Availability from "./components/Availability";
import { availability } from "./data/availability";

export default function Career() {
  return (
    <div className="d-flex w-100 flex-column pt-4 pb-5 ps-3 pe-3 gap-3">
      <div className="text-center pb-1">
        <SectionTitle title="Career" />
      </div>
      <Banner
        image="/assets/model2.jpg"
        bottomComponent={
          <>
            <p className="m-0 text-white">Applicants may send resumes to:</p>
            <p className="m-0 text-secondary">hr@forbesfinancial.com.ph</p>
          </>
        }
      />
      <Positions positions={positions} />
      <Availability availability={availability} />
      <Banner
        image="/assets/model3.jpg"
        bottomComponent={
          <div className="d-flex gap-2 align-items-center opacity-50">
            <img style={{ width: "1.5rem" }} src="/f2.png" alt="Forbes" />
            <p className="m-0 text-white" style={{ fontSize: ".8rem" }}>
              Forbes Financial Consulting Corporation
            </p>
          </div>
        }
      />
    </div>
  );
}
